import type React from 'react';

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  ariaLabel?: string;
  children: React.ReactNode;
}

const SvgIcon: React.FC<SvgIconProps> = ({
  ariaLabel,
  children,
  ...props
}) => {
  // Conditionally apply accessibility props based on ariaLabel
  // if no ariaLabel is passed in, show icon as presentational
  const accessibilityProps = ariaLabel
    ? {
      'aria-label': ariaLabel,
    } :
    {
      'aria-hidden': true,
      role: 'presentation',
    };

  return (
    <svg
      {...props}
      {...accessibilityProps}
    >
      {children}
    </svg>
  );
};

export default SvgIcon;
